import React from "react";

import { GridCell } from "@progress/kendo-react-grid";
import BooleanCell from "./BooleanCell";
import GridDateCell from "./GridDateCell";
import GridDateTimeCell from "./GridDateTimeCell";
import GridEnumCell from "./GridEnumCell";
import GridNumericCell from "./GridNumericCell";
import GridTextCell from "./GridTextCell";
import TranslateCell from "./TranslateCell";

/**
 *
 * @param {{cellProps:import("@progress/kendo-react-grid").GridCellProps,column:import("@progress/kendo-react-grid").GridColumnProps}} props
 */
export default function GridCellSelector(props) {
  if (props.column.cell) return <props.column.cell {...props.cellProps} />;
  if (props.column.tKey)
    return <TranslateCell {...props.cellProps} {...props.column} />;
  if (props.column.enum)
    return <GridEnumCell {...props.cellProps} enum={props.column.enum} />;
  else if (props.column.filter === "date") {
    return <GridDateCell {...props.cellProps} type={props.column.type} />;
  } else if (props.column.filter === "datetime") {
    return <GridDateTimeCell {...props.cellProps} type={props.column.type} />;
  } else if (
    props.column.type === "boolean" ||
    props.column.type === "active"
  ) {
    return <BooleanCell {...props.cellProps} type={props.column.type} />;
  } else if (props.column.filter === "numeric") {
    return (
      <GridNumericCell
        {...props.cellProps}
        min={props.column.min}
        max={props.column.max}
      />
    );
  } else if (props.column.filter === "text" || !props.column.filter) {
    return <GridTextCell {...props.cellProps} {...props.column} />;
  }
  return <GridCell {...props.cellProps} />;
}
